/* YATS — "The life of a book" lifecycle scene (v3: dot-video scenes).
   Scroll-scrubbed Three.js DOT WALL in the language of the network globe
   (yats-sus-network.js). Each stage is a short generated scene (Veo, made on
   the Mac mini) baked into assets/yats-life-<scene>.bin: a fixed 128x72
   jittered grid of dots, a depth map (3D relief + parallax) and 24 frames of
   per-dot brightness that play as a ping-pong loop, so the scene moves like a
   short film on an LED wall. Scenes dissolve into each other on the same dot
   grid as you scroll; a small infinity-loop device in the rail carries
   progress. Degrades to the static card grid without WebGL / with reduced
   motion. Format YLD1: 'YLD1' u16 W u16 H u8 F u8 fps u16 0 | depth W*H | F x W*H. */
(function () {
  'use strict';

  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function smooth(t) { t = clamp(t, 0, 1); return t * t * (3 - 2 * t); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function hash(i) { var x = Math.sin(i * 12.9898 + 78.233) * 43758.5453; return x - Math.floor(x); }

  var WALL_W = 2.4, DEPTH = 0.6;

  function parse(buf) {
    var dv = new DataView(buf), u8 = new Uint8Array(buf);
    if (u8[0] !== 89 || u8[1] !== 76 || u8[2] !== 68 || u8[3] !== 49) return null; /* 'YLD1' */
    var W = dv.getUint16(4, true), H = dv.getUint16(6, true), F = u8[8], fps = u8[9] || 8, n = W * H, o = 12;
    if (u8.length < o + n * (F + 1)) return null;
    var depth = u8.subarray(o, o + n); o += n;
    var frames = [];
    for (var f = 0; f < F; f++) { frames.push(u8.subarray(o, o + n)); o += n; }
    return { W: W, H: H, F: F, fps: fps, n: n, depth: depth, frames: frames };
  }

  function init() {
    var sec = document.querySelector('[data-yats-suslife]');
    if (!sec || sec.__yatsLife) return;
    sec.__yatsLife = true;
    var stage = sec.querySelector('[data-suslife-stage]');
    var canvas = sec.querySelector('[data-suslife-canvas]');
    var fallback = sec.querySelector('[data-suslife-fallback]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function bail() { if (stage) stage.style.display = 'none'; if (fallback) fallback.removeAttribute('hidden'); sec.classList.add('suslife-static'); }
    if (reduce || !canvas || !window.fetch) { bail(); return; }
    if (!window.THREE) {
      var tries = 0, tm = setInterval(function () { if (window.THREE) { clearInterval(tm); sec.__yatsLife = false; init(); } else if (++tries > 50) { clearInterval(tm); bail(); } }, 100);
      return;
    }
    var renderer;
    try { renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true }); } catch (e) { bail(); return; }
    var DPR = Math.min(window.devicePixelRatio || 1, 2);
    renderer.setPixelRatio(DPR);
    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(40, 1, 0.1, 50);
    camera.position.set(0, 0, 3.4);
    var world = new THREE.Group();
    scene.add(world);

    var dotCv = document.createElement('canvas'); dotCv.width = dotCv.height = 64;
    var dctx = dotCv.getContext('2d'); var dg = dctx.createRadialGradient(32, 32, 0, 32, 32, 32);
    dg.addColorStop(0, 'rgba(255,255,255,1)'); dg.addColorStop(0.3, 'rgba(255,255,255,0.9)'); dg.addColorStop(1, 'rgba(255,255,255,0)');
    dctx.fillStyle = dg; dctx.fillRect(0, 0, 64, 64);
    var dotTex = new THREE.CanvasTexture(dotCv);

    /* ---------- the wall: one fixed dot grid, brightness = the film ---------- */
    var panels = sec.querySelectorAll('[data-suslife-panel]');
    var S = panels.length; if (!S) { bail(); return; }
    var srcs = []; panels.forEach(function (p) { srcs.push(p.getAttribute('data-suslife-src') || ''); });
    var W = 128, H = 72, N = W * H, WALL_H = WALL_W * H / W;
    var gridX, gridY, jz, scatter, livePos, liveCol, liveSize, geo, pts, mat;
    function buildGrid() {
      N = W * H; WALL_H = WALL_W * H / W;
      var pitch = WALL_W / W;
      gridX = new Float32Array(N); gridY = new Float32Array(N); jz = new Float32Array(N);
      scatter = new Float32Array(N * 3); livePos = new Float32Array(N * 3); liveCol = new Float32Array(N * 3); liveSize = new Float32Array(N);
      for (var i = 0; i < N; i++) {
        var gx = i % W, gy = Math.floor(i / W);
        gridX[i] = ((gx + 0.5) / W - 0.5) * WALL_W + (hash(i) - 0.5) * pitch * 0.55;
        gridY[i] = (0.5 - (gy + 0.5) / H) * WALL_H + (hash(i + 7919) - 0.5) * pitch * 0.55;
        jz[i] = (hash(i + 104729) - 0.5) * 0.03;
        var sr = 2.2 + hash(i + 3) * 3.5, u = hash(i + 11) * 2 - 1, ph = hash(i + 17) * 6.2832, ur = Math.sqrt(1 - u * u);
        scatter[i * 3] = Math.cos(ph) * ur * sr; scatter[i * 3 + 1] = u * sr; scatter[i * 3 + 2] = Math.sin(ph) * ur * sr;
        livePos[i * 3] = scatter[i * 3]; livePos[i * 3 + 1] = scatter[i * 3 + 1]; livePos[i * 3 + 2] = scatter[i * 3 + 2];
        liveCol[i * 3] = 0.05; liveCol[i * 3 + 1] = 0.18; liveCol[i * 3 + 2] = 0.16; liveSize[i] = 0.012;
      }
      if (pts) { world.remove(pts); geo.dispose(); }
      geo = new THREE.BufferGeometry();
      geo.setAttribute('position', new THREE.BufferAttribute(livePos, 3));
      geo.setAttribute('color', new THREE.BufferAttribute(liveCol, 3));
      geo.setAttribute('aSize', new THREE.BufferAttribute(liveSize, 1));
      pts = new THREE.Points(geo, mat);
      world.add(pts);
    }
    mat = new THREE.ShaderMaterial({
      uniforms: { uMap: { value: dotTex }, uPx: { value: 1000 } },
      vertexShader: 'uniform float uPx; attribute float aSize; varying vec3 vC; void main(){ vC = color; vec4 mv = modelViewMatrix * vec4(position, 1.0); gl_PointSize = aSize * uPx / -mv.z; gl_Position = projectionMatrix * mv; }',
      fragmentShader: 'uniform sampler2D uMap; varying vec3 vC; void main(){ float a = texture2D(uMap, gl_PointCoord).a; gl_FragColor = vec4(vC * a, a); }',
      vertexColors: true, transparent: true, depthWrite: false, blending: THREE.AdditiveBlending
    });
    buildGrid();

    /* ---------- scene data (lazy, current + next) ---------- */
    var scenes = new Array(S), loading = new Array(S);
    function load(i) {
      if (i < 0 || i >= S || scenes[i] || loading[i] || !srcs[i]) return;
      loading[i] = true;
      fetch(srcs[i]).then(function (r) { return r.ok ? r.arrayBuffer() : null; }).then(function (buf) {
        var d = buf && parse(buf);
        if (!d) { loading[i] = 'failed'; return; } /* missing or bad film: keep the shimmer, don't refetch */
        if (d.W !== W || d.H !== H) { if (!scenes.some(Boolean)) { W = d.W; H = d.H; buildGrid(); } else { return; } }
        scenes[i] = d;
      }).catch(function () { loading[i] = false; });
    }
    load(0); load(1);

    /* ---------- DOM hooks ---------- */
    var intro = sec.querySelector('[data-suslife-intro]');
    var railLabel = sec.querySelector('[data-suslife-rail-label]');
    var labels = []; panels.forEach(function (p) { labels.push(p.getAttribute('data-suslife-label') || ''); });
    var infTrack = sec.querySelector('[data-suslife-inf-track]');
    var infProg = sec.querySelector('[data-suslife-inf-prog]');
    var infMarker = sec.querySelector('[data-suslife-inf-marker]');
    var infNodes = sec.querySelectorAll('[data-suslife-dot]');
    var infLen = 0;
    if (infTrack && infProg) {
      var d = '', A = 104, CX = 120, CY = 60;
      for (var s = 0; s <= 200; s++) { var t = -Math.PI / 2 + (s / 200) * Math.PI * 2, den = 1 + Math.sin(t) * Math.sin(t); var x = CX + A * Math.cos(t) / den, y = CY + A * Math.sin(t) * Math.cos(t) / den * 0.92; d += (s ? ' L' : 'M') + x.toFixed(1) + ' ' + y.toFixed(1); }
      d += ' Z';
      infTrack.setAttribute('d', d); infProg.setAttribute('d', d);
      infLen = infProg.getTotalLength();
      infProg.style.strokeDasharray = infLen; infProg.style.strokeDashoffset = infLen;
      infNodes.forEach(function (n, i) { var p = infProg.getPointAtLength(infLen * i / S); n.setAttribute('cx', p.x.toFixed(1)); n.setAttribute('cy', p.y.toFixed(1)); });
    }
    var P_INTRO = 0.08;
    infNodes.forEach(function (n, i) {
      n.addEventListener('click', function () {
        var total = sec.offsetHeight - window.innerHeight, top = sec.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: top + total * (P_INTRO + (1 - P_INTRO) * ((i + 0.5) / S)), behavior: 'smooth' });
      });
    });

    /* ---------- scroll + render ---------- */
    var p = 0, idx = 0, local = 0, lastIdx = -1, raf = 0, running = false, t0 = performance.now();
    var wide = true, wallScale = 1, worldX = 0, worldY = 0, baseRotY = 0;
    function updateScroll() {
      var r = sec.getBoundingClientRect(), total = sec.offsetHeight - window.innerHeight;
      p = total > 0 ? clamp(-r.top / total, 0, 1) : 0;
      var cp = clamp((p - P_INTRO) / (1 - P_INTRO), 0, 1);
      idx = Math.min(S - 1, Math.floor(cp * S)); local = clamp(cp * S - idx, 0, 1);
      if (intro) { var iv = 1 - clamp(p / (P_INTRO * 0.85), 0, 1); intro.style.opacity = String(iv); intro.style.transform = 'translateY(' + (-(1 - iv) * 46) + 'px)'; intro.style.visibility = iv <= 0 ? 'hidden' : 'visible'; }
      var introDone = p > P_INTRO * 0.8;
      sec.classList.toggle('suslife-introing', !introDone);
      panels.forEach(function (pa, i) { pa.classList.toggle('on', i === idx && introDone); });
      if (infProg) infProg.style.strokeDashoffset = String(infLen * (1 - cp));
      if (infMarker && infLen) { var mp = infProg.getPointAtLength(infLen * cp); infMarker.setAttribute('transform', 'translate(' + mp.x.toFixed(1) + ' ' + mp.y.toFixed(1) + ')'); }
      if (idx !== lastIdx) {
        infNodes.forEach(function (n, i) { n.classList.toggle('on', i === idx); n.classList.toggle('done', i < idx); });
        if (railLabel) railLabel.textContent = labels[idx] || '';
        sec.classList.toggle('suslife-closing', idx === S - 1);
        lastIdx = idx;
        load(idx); load(idx + 1); load(idx + 2);
      }
    }
    /* brightness -> colour: off-dot teal, mid green, highlight paper-gold */
    function shade(b, j) {
      var r, g, bl, k = 0.2 + b * 1.0;
      if (b < 0.55) { var t = b / 0.55; r = lerp(0.05, 0.27, t); g = lerp(0.2, 0.85, t); bl = lerp(0.18, 0.52, t); }
      else { var t2 = (b - 0.55) / 0.45; r = lerp(0.27, 1.0, t2); g = lerp(0.85, 0.95, t2); bl = lerp(0.52, 0.7, t2); }
      liveCol[j] = r * k; liveCol[j + 1] = g * k; liveCol[j + 2] = bl * k;
    }
    function framePair(sc, now) {
      var cyc = 2 * (sc.F - 1), q = ((now / 1000) * sc.fps) % cyc, f = q <= sc.F - 1 ? q : cyc - q;
      var f0 = Math.floor(f), f1 = Math.min(sc.F - 1, f0 + 1);
      return { a: sc.frames[f0], b: sc.frames[f1], t: f - f0 };
    }
    var lastFrameTime = 0;
    function frame(now) {
      raf = 0;
      var dt = Math.min(0.05, (now - t0) / 1000); t0 = now;
      var form = smooth(clamp(p / P_INTRO, 0, 1));
      var A = scenes[idx], B = idx < S - 1 ? scenes[idx + 1] : null;
      var mt = (A && B) ? smooth(clamp((local - 0.72) / 0.28, 0, 1)) : 0;
      var fa = A ? framePair(A, now) : null, fb = B && mt > 0 ? framePair(B, now) : null;
      var i, j, b, z;
      for (i = 0; i < N; i++) {
        j = i * 3;
        if (fa) {
          b = lerp(fa.a[i], fa.b[i], fa.t) / 255; z = A.depth[i] / 255;
          if (fb) { b = lerp(b, lerp(fb.a[i], fb.b[i], fb.t) / 255, mt); z = lerp(z, B.depth[i] / 255, mt); }
        } else { b = 0.08 + 0.06 * Math.sin(now / 700 + i * 0.13); z = 0.5; }
        var tx = gridX[i], ty = gridY[i], tz = (z - 0.5) * DEPTH + jz[i];
        livePos[j] = lerp(scatter[j], tx, form); livePos[j + 1] = lerp(scatter[j + 1], ty, form); livePos[j + 2] = lerp(scatter[j + 2], tz, form);
        shade(b, j);
        liveSize[i] = 0.011 + b * b * 0.016;
      }
      geo.attributes.position.needsUpdate = true;
      geo.attributes.color.needsUpdate = true;
      geo.attributes.aSize.needsUpdate = true;
      /* gentle parallax sway; the wall faces the reader on phones, angles toward the text on desktop */
      world.rotation.y = baseRotY + Math.sin(now / 4200) * 0.09;
      world.rotation.x = (wide ? 0.0 : 0.06) + Math.sin(now / 6100) * 0.035;
      world.position.x = worldX; world.position.y = worldY;
      world.scale.setScalar(wallScale);
      renderer.render(scene, camera);
      if (running) raf = requestAnimationFrame(frame);
    }
    function start() { if (!running) { running = true; t0 = performance.now(); raf = requestAnimationFrame(frame); } }
    function stop() { running = false; if (raf) { cancelAnimationFrame(raf); raf = 0; } }
    new IntersectionObserver(function (es) { es.forEach(function (e) { e.isIntersecting ? start() : stop(); }); }, { rootMargin: '40% 0px' }).observe(sec);
    function resize() {
      var w = stage.clientWidth, h = stage.clientHeight; if (!w || !h) return;
      renderer.setSize(w, h, false); camera.aspect = w / h; camera.updateProjectionMatrix();
      var halfH = Math.tan(camera.fov * Math.PI / 360) * 3.4, halfW = halfH * camera.aspect;
      wide = camera.aspect > 1.05;
      if (wide) {
        /* the wall lives in the right ~56% of the view, angled toward the copy */
        var avail = halfW * 1.12; wallScale = Math.min(avail / WALL_W, (halfH * 1.5) / WALL_H);
        worldX = halfW * 0.44; worldY = 0.04; baseRotY = -0.3;
      } else {
        wallScale = (halfW * 1.92) / WALL_W; worldX = 0; worldY = halfH * 0.42; baseRotY = 0;
      }
      mat.uniforms.uPx.value = (h * DPR) / (2 * Math.tan(camera.fov * Math.PI / 360));
    }
    window.addEventListener('resize', function () { resize(); updateScroll(); });
    document.addEventListener('scroll', updateScroll, { passive: true, capture: true });
    resize(); updateScroll(); start();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
